import {Component} from '@angular/core'
import {EnvService} from "../../services/env.service";

@Component({
    selector: `app-breadcrumb-start-link`,
    template: `
        <a [href]="envService.frontendBaseUrl" target="_blank"><span
                class="text">{{ 'global.breadcrumbs.startpage' | translate }}</span></a>
    `
})
export class BreadcrumbsStartLinkComponent {
    constructor(
            public envService: EnvService,
    ) {

    }
}
